export default __webpack_public_path__ + "static/media/about5.9f13a35a.jpg";